import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { settingsApi, type UpdateMePayload } from './api';

export const settingsKeys = {
  me: ['settings', 'me'] as const,
  billing: ['settings', 'billing'] as const,
};

export function useMe() {
  return useQuery({
    queryKey: settingsKeys.me,
    queryFn: settingsApi.getMe,
  });
}

export function useBilling() {
  return useQuery({
    queryKey: settingsKeys.billing,
    queryFn: settingsApi.getBilling,
  });
}

export function useUpdateMe() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: UpdateMePayload) => settingsApi.updateMe(body),
    onSuccess: (me) => {
      qc.setQueryData(settingsKeys.me, me);
    },
  });
}

export function useDeleteAccount() {
  return useMutation({
    mutationFn: () => settingsApi.deleteMe(),
  });
}
